import { TaskCenterTypesV2 } from '@frontend/api-task-center';
import { SelectedFilters } from '@frontend/task-center-scope';

interface PrepareFiltersParams {
  locationIds: string[];
  selectedFilters: SelectedFilters;
  assigneeFilter?: string;
  statuses?: TaskCenterTypesV2.SchemaTypes.Enums.TaskStatus[];
  patientId?: string;
}

export const prepareTaskFilters = ({
  locationIds,
  selectedFilters,
  assigneeFilter,
  statuses,
  patientId,
}: PrepareFiltersParams): TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['filters'] => {
  const filters: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['filters'] = {
    locationId: locationIds,
    status: statuses?.length ? statuses : undefined,
    patientId: patientId ? [patientId] : undefined,
  };

  if (selectedFilters.source) {
    filters['source'] = selectedFilters.source;
  }

  if (selectedFilters.createdBy) {
    filters['createdBy'] = selectedFilters.createdBy;
  }

  if (assigneeFilter) {
    filters['assignee'] = [assigneeFilter];
  }

  return filters;
};

export const preparePagination = (
  selectedFilters: SelectedFilters
): TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['pagination'] => {
  const pagination: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['pagination'] = {};

  if (selectedFilters.sortType) {
    pagination['sortField'] = selectedFilters.sortType;
    pagination['sortType'] = TaskCenterTypesV2.SchemaTypes.Enums.SortType.SORT_ASC;
  }

  return pagination;
};
